import { render, staticRenderFns } from "./thread_individual_report.vue?vue&type=template&id=40bfea66"
import script from "./thread_individual_report.vue?vue&type=script&lang=js"
export * from "./thread_individual_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports